import React from "react"
import PropTypes from "prop-types"
import axios from "axios"
import {observer} from "mobx-react"
import BienStore from "./BienStore"
import { HashRouter as Router, Route, Link } from "react-router-dom"
import Explications from "./pages/Explications"
import Elementsdebases from "./pages/Elementsdebases"
import DonneesImmeubles from "./pages/DonneesImmeubles"
import Confirm from "./pages/Confirm"
import Pieces from "./pages/Pieces"
import Piece from "./pages/Piece"
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AnimatedSwitch } from 'react-router-transition';


@observer
class Routeur extends React.Component {
  constructor(props) {
    super(props);
    let state={
      intervalId: ""
    }
    if(props.expert==true){
      BienStore.callBackExpert = props.callBackExpert
      BienStore.expert = true
    }
  }
  componentDidMount(){
    let intervalId = setInterval(()=>{
      BienStore.saveState()
    }, 10000);
   this.setState({intervalId: intervalId});
  }
  componentWillUnmount(){
    clearInterval(this.state.intervalId);

  }
  saveState(e){
    e.preventDefault()
    BienStore.saveState()
  }

  render () {
    return (
      <React.Fragment>
      <Router>
{/*      <div className="row">
       <p className=""><a className="btn btn-large" onClick={this.saveState}><i className="material-icons">save</i></a></p>
      </div>*/}

      <Route path="/" exact component={Explications}/>
      <Route path="/Elementsdebases" exact component={Elementsdebases}/>
      <Route path="/Donneesdubien" exact component={DonneesImmeubles}/>
      <Route path="/Pieces" exact component={Pieces}/>
      <Route path="/piece/:id" component={Piece}/>
      <Route path="/done" component={Confirm}/>

      <ToastContainer
        position="top-right"
        autoClose={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange={false}
        draggable={false}
        />

      </Router>
      </React.Fragment>
    );
  }
}

export default Routeur
